import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { Field } from '@ahmdigital/ui';
import { map, toString } from 'lodash/fp';
import moment from 'moment';
import React from 'react';

import { DateStartText, HelpLink, PremiumChangeDropdown, StyledIcon, Wrapper } from './styles';
import { PREMIUM_REVIEW_TOGGLE_STYLE, USE_FUTURE_EFFECTIVE_DATE } from '../../ahm-constants/ui';
import PREMIUM_CHANGE from '../../features/premium-change/constants';
import PriceActions from '../../actions/price';
import selectIsPremiumChangeEnabled from '../../selectors/select-is-premium-change-enabled';
import styles from './styles.module.sass';

const formattedEffectiveDate = moment(PREMIUM_CHANGE.FUTURE_EFFECTIVE_DATE).format('D MMMM');

// @ts-expect-error: Lodash hasn't typed map to include convert.
const mapWithKey = map.convert({ cap: false });
const options = mapWithKey(
  (value: string, key: string) => ({
    text: value,
    value: key,
  }),
  PREMIUM_CHANGE.TOGGLE_LABELS,
);

type PremiumChangePromptProps = {
  actions: { price: { changeEffectiveDate: (value: boolean) => void } };
  isAlternativePage?: boolean;
  isPremiumChangeEnabled?: boolean;
  toggleModal: () => void;
  useFutureEffectiveDate: boolean;
  type?: PREMIUM_REVIEW_TOGGLE_STYLE;
};

const PremiumChangePrompt = ({
  actions,
  isAlternativePage = false,
  isPremiumChangeEnabled = false,
  toggleModal,
  // @ts-expect-error - Automatic, Please fix when editing this file
  type = null,
  useFutureEffectiveDate,
}: PremiumChangePromptProps) => {
  if (!isPremiumChangeEnabled) {
    return null;
  }

  const onChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const effectiveDateChangeValue = event.target.value;
    const shouldChangeEffectiveDate = effectiveDateChangeValue === 'true';
    actions.price.changeEffectiveDate(shouldChangeEffectiveDate);
  };

  const isReadOnly = type === PREMIUM_REVIEW_TOGGLE_STYLE.READ_ONLY;

  return (
    <Wrapper isAlternativePage={isAlternativePage} type={type}>
      {isReadOnly ? (
        <> {useFutureEffectiveDate ? USE_FUTURE_EFFECTIVE_DATE.AFTER : USE_FUTURE_EFFECTIVE_DATE.BEFORE} </>
      ) : (
        <PremiumChangeDropdown type={type}>
          <Field
            className={styles.container}
            inputVariant={['inline', 'sharp', styles.input]}
            name="premiumChangeToggle"
            onChange={onChange}
            options={options}
            size="auto"
            type="dropdown"
            value={toString(useFutureEffectiveDate)}
            label="Price"
            labelVariant={styles.label}
          />
        </PremiumChangeDropdown>
      )}
      <DateStartText>
        {formattedEffectiveDate}{' '}
        <HelpLink onClick={toggleModal} aria-label="More about Premium Review">
          <StyledIcon fill="currentColor" name="question-circle" type={type} />
        </HelpLink>
      </DateStartText>
    </Wrapper>
  );
};

type StateProps = {
  isPremiumChangeEnabled: boolean;
  useFutureEffectiveDate: boolean;
};

const mapStateToProps = (state: any): StateProps => ({
  isPremiumChangeEnabled: selectIsPremiumChangeEnabled(state),
  useFutureEffectiveDate: state.price.useFutureEffectiveDate,
});

type DispatchProps = {
  actions: { price: { changeEffectiveDate: (value: boolean) => void } };
};

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
  actions: {
    price: bindActionCreators(PriceActions, dispatch),
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PremiumChangePrompt);

export { PremiumChangePrompt as PremiumChangePromptForTest, mapStateToProps, mapDispatchToProps };
